// extracted by mini-css-extract-plugin
module.exports = {"external":"ExternalLinkModal_external__YZMuW","closeIcon":"ExternalLinkModal_closeIcon__PD_wZ","buttonBlock":"ExternalLinkModal_buttonBlock__k_YnB"};